import ShowIFrame from 'wrapper/lib/frames/utils/ShowIFrame'
import { lockPage } from 'wrapper/lib/frames/utils/toggleBodyScroll'
import { PROMPT_TAG } from 'common/tags'

const DisplayIFrame = (message) => {
    if (message.includes('FRAME/SHOW_CHILD/')) {
        const tag = message.replace('FRAME/SHOW_CHILD/', '')
        if (tag === PROMPT_TAG) {
            lockPage()
        }
        ShowIFrame(tag)
    }
}

export default DisplayIFrame
